import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Sopprime l'errore benigno "ResizeObserver loop" che in dev/preview genera
// un overlay CRA che copre e blocca l'interazione con la UI.
const swallowResizeObserver = (e) => {
  const msg = e?.message || "";
  if (msg.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", swallowResizeObserver);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
